import { ReleaseNoteType } from "../Interface";
import {
  releaseNotesContentMap,
  WEB_RELEASE_NOTES_VERSIONS,
} from "../Pages/ReleaseNotesDetail/releaseNotesContent";

/**
 * Dynamically generates release notes data from releaseNotesContent.
 * Whenever a new version is added to releaseNotesContentMap,
 * it will automatically appear here without manual updates.
 */
const generateReleaseNotesData = (): ReleaseNoteType[] => {
  return WEB_RELEASE_NOTES_VERSIONS.map((version, index) => {
    const content = releaseNotesContentMap[version];

    // Determine status based on version position:
    // First (latest) version is "current", rest are "deprecated"
    const status: "current" | "upcoming" | "deprecated" =
      index === 0 ? "current" : "deprecated";

    return {
      version,
      status,
      description: content.overview,
      date: content.releaseDate,
      documentLink: null, // Links can be added to content if needed
    };
  }).sort((a, b) => {
    // Sort by version number in descending order (newest first)
    const aVersion = a.version.split(".").map(Number);
    const bVersion = b.version.split(".").map(Number);
    for (let i = 0; i < Math.max(aVersion.length, bVersion.length); i++) {
      const aPart = aVersion[i] || 0;
      const bPart = bVersion[i] || 0;
      if (aPart !== bPart) return bPart - aPart;
    }
    return 0;
  });
};

const releaseNotesData: ReleaseNoteType[] = generateReleaseNotesData();

export { releaseNotesData };
